import CommonModal from "./CommonModal";
export default CommonModal;
